import InfiniteScroll from 'react-infinite-scroll-component';
import { MeetingItem } from '@/modules/common/components/items/MeetingItem.tsx';
import { EmptyListState, Spinner } from 'ui';
import { ScheduledMeetingListItem } from 'compliance-api';

interface MeetingsListProps {
  meetings: ScheduledMeetingListItem[];
  isLoading: boolean;
  isSearchUsed: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void | Promise<unknown>;
}

export const MeetingsList = ({
  meetings,
  isLoading,
  isSearchUsed,
  hasNextPage,
  fetchNextPage,
}: MeetingsListProps) => {
  return (
    <>
      <EmptyListState
        title="No meetings created yet"
        description="You can use this feature to create Microsoft Teams meetings and Calendar records for online and offline meetings."
        isLoading={isLoading}
        isSearchUsed={isSearchUsed}
        itemsCount={meetings.length}
      />
      {isLoading && (
        <div className="flex h-full w-full items-center justify-center">
          <Spinner size="lg" variant="primary" />
        </div>
      )}
      {!!meetings.length && (
        <InfiniteScroll
          next={() => {
            void fetchNextPage();
          }}
          dataLength={meetings.length}
          hasMore={!!hasNextPage}
          className="w-full flex flex-col space-y-2"
          style={{ overflow: 'unset' }}
          loader={
            <div className="flex justify-center items-center h-16 w-full">
              <Spinner size="md" variant="primary" />
            </div>
          }
          scrollableTarget="scrollable"
        >
          {meetings.map(meeting => (
            <MeetingItem key={meeting.id} meeting={meeting} />
          ))}
        </InfiniteScroll>
      )}
    </>
  );
};
